<div class="full-width-image-section home-top">
    <div class="arrow-up">
        <next-topbar></next-topbar>
        <next-menu></next-menu>

        <div class="container white">
            <div class="row">
                <div class="col-sm-12 text-center">
                    <h1>{{ 'INSURANCE.HOME.COMPONENTS.INDEX.TITLE' | translate }}</h1>
                </div>
            </div>

            <p class="home-insurance-text">
                {{ 'INSURANCE.HOME.COMPONENTS.INDEX.INSURANCE_TEXT' | translate }}
            </p>

            <div class="row">
                <div class="col-xs-12">
                    <div class="icon-bg center no-circle">
                        <div class="icon-wrap">
                            <i class="nf nf-home-icon-v3"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container">
    <div class="row">
        <div class="col-sm-12 text-center">
            <br />
            <br />
            <calculate-btn [gotoLink]="navigationService.getUrl('calculate-home')" [productName]="'INSURANCE.HOME.PRODUCT' | translate | uppercase"></calculate-btn>
            <br />
            <br />
        </div>
    </div>
</div>

<home-cover></home-cover>

<trustpilot-carousel></trustpilot-carousel>

<div class="gray-bg">
    <div class="container">
        <next-faqarticle [category]="'FAQ_HOME'"></next-faqarticle>
    </div>
</div>

<nicetoknow [pagecode]="'INSURANCE_HOME_NICETOKNOW'"></nicetoknow>

<next-footer></next-footer>
